
import { IFormRoleData } from './type'

export const initValueFormRoles: IFormRoleData = {
  name: '',
  description: ''
}
